export const languageKeys = {
    all: ['languages'] as const,
};
